// Idea-first navigation: five intellectual paths through the work.
// Each path aggregates essays, concepts, frameworks, and source notes.

export interface PathContents {
  essays: string[];      // idea slugs
  concepts: string[];    // concept slugs
  frameworks: string[];  // framework slugs
  sourceNotes: string[]; // research slugs
}

export interface Path {
  id: string;
  numeral: string;
  title: string;
  lede: string;
  contents: PathContents;
}

export const PATHS: Path[] = [
  {
    id: "ai-and-human-judgment",
    numeral: "I",
    title: "AI & Human Judgment",
    lede:
      "What happens to decision-making when machines produce plausible answers faster than we can verify them — and how judgment atrophies once deferral becomes the default.",
    contents: {
      essays: ["the-biggest-obstacle-to-the-climate-crisis-is-our-brain"],
      concepts: ["algorithmic-surrender", "epistemic-weaponization"],
      frameworks: [],
      sourceNotes: [],
    },
  },
  {
    id: "ai-and-sustainability",
    numeral: "II",
    title: "AI & Sustainability",
    lede:
      "A technology that accelerates efficiency and material demand at the same time, and the accounting layer no institution is yet required to keep.",
    contents: {
      essays: [
        "can-ai-solve-the-climate-crisis",
        "the-energy-paradox-of-artificial-intelligence",
      ],
      concepts: [
        "ai-sustainability-paradox",
        "efficiency-debt",
        "jevons-paradox",
        "rebound-effect",
        "decoupling-thesis",
      ],
      frameworks: ["ai-sustainability-paradox"],
      sourceNotes: ["iea-energy-and-ai-2025", "unep-state-of-finance-for-nature-2026"],
    },
  },
  {
    id: "trust-and-epistemic-infrastructure",
    numeral: "III",
    title: "Trust & Epistemic Infrastructure",
    lede:
      "How societies keep — or lose — the shared machinery that lets them tell claim from evidence, and expertise from performance.",
    contents: {
      essays: [],
      concepts: ["epistemic-weaponization", "algorithmic-surrender"],
      frameworks: [],
      sourceNotes: [],
    },
  },
  {
    id: "the-loneliness-economy",
    numeral: "IV",
    title: "The Loneliness Economy",
    lede:
      "The unspoken economics of a culture that sells connection back to the people it isolated — attention as extractive infrastructure.",
    contents: {
      essays: ["the-loneliness-economy"],
      concepts: ["loneliness-economy", "attention-mining"],
      frameworks: [],
      sourceNotes: [],
    },
  },
  {
    id: "sustainability-critique",
    numeral: "V",
    title: "Sustainability Critique",
    lede:
      "Reading transformation claims — green, corporate, technological — against the cost of the action they name, not the language they use.",
    contents: {
      essays: [
        "what-is-sustainability-a-critique",
        "the-sustainability-fetish-a-critical-perspective",
        "efficiency-a-glutton-in-disguise",
      ],
      concepts: ["washing-economy", "commitment-debt", "efficiency-debt"],
      frameworks: ["washing-economy-test", "commitment-debt-audit"],
      sourceNotes: ["unep-state-of-finance-for-nature-2026"],
    },
  },
];
